export default {"src":"/_next/static/media/shareTwitBlue.b9fb5f49.svg","height":32,"width":32};